import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3634_6022)">
        <rect width="48" height="48" rx="8" fill="#09173D" />
        <path
          d="M26.3897 17.7868L29.9318 15.7334C31.4353 14.8618 33.9464 14.9507 34.7433 16.3366C35.5402 17.7226 34.3614 19.9506 32.8579 20.8222L29.3157 22.8757L28.0478 32.3958C27.9777 32.922 27.6696 33.3853 27.2126 33.6503L26.1413 34.2713C25.3244 34.7449 24.2801 34.4587 23.8076 33.6368C23.659 33.3784 23.5795 33.0857 23.577 32.7876L23.5189 25.9126L21.4579 26.9535L20.2812 30.1987C20.2168 30.5535 20.0009 30.862 19.6899 31.0423L19.0493 31.4137C18.3808 31.8012 17.5269 31.5672 17.1408 30.8957C17.0521 30.7415 16.9933 30.5717 16.9674 30.3956L16.8858 26.9554L14.007 24.5911C13.4089 24.0838 13.3277 23.1856 13.8291 22.5822C13.9355 22.4543 14.0634 22.3461 14.2072 22.2628L14.8478 21.8914C15.1587 21.7112 15.5328 21.6777 15.871 21.799L18.9436 22.5809L20.7173 21.411L14.9642 17.8556C14.1439 17.3487 13.8811 16.2704 14.3789 15.4438C14.5305 15.1923 14.7427 14.9834 14.9961 14.8365L16.0451 14.2283C16.5021 13.9634 17.0558 13.9272 17.5447 14.1293L26.3897 17.7868Z"
          fill="#1F336E"
        />
      </g>
      <defs>
        <clipPath id="clip0_3634_6022">
          <rect width="48" height="48" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
